<template>
  <div>{{ test }}</div>
</template>

<script>
export default {
  data() {
    return {
      test: 123

    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
